import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_PLATE_DESIGN_TEMPLATE_QUERY = gql`
  query GetPlateDesignTemplate($id: StrictString!) @skipAudit @engComponent(name: PIPELINES) {
    plateDesignTemplate(id: $id) {
      ... on PlateDesignTemplateNode {
        id
        name
        editUrl
        scratchPlate {
          ... on ScratchPlateNode {
            id
          }
        }
        createdAt
        modifiedAt
        archiveRecord {
          __typename
          purpose
        }
        creator {
          name
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
